import styled from '@emotion/styled';
import { sdsPrimitiveColor } from '@staging-design-system/tokens';
import { rem } from '@utils';

const Root = styled.article`
  background: ${({ theme }) => theme.palette.common.white};
  border: ${rem(1)} solid ${({ theme }) => theme.palette.grey['200']};
  border-radius: ${rem(8)};
  display: flex;
  flex-direction: column;
  gap: ${rem(10)};
  padding: ${rem(16)};
  width: 100%;
`;

const Title = styled.h3`
  color: ${({ theme }) => theme.palette.common.black};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${rem(20)};
  font-weight: 600;
  line-height: ${rem(32)};
  margin: 0;
`;

const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
`;

const Label = styled.p`
  color: ${({ theme }) => theme.palette.common.black};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${rem(12)};
  font-weight: 400;
  line-height: ${rem(16)};
  margin: 0;
`;

const BarRow = styled.div`
  align-items: center;
  display: flex;
  gap: ${rem(12)};
`;

const BarTrack = styled.div`
  background: ${({ theme }) => theme.palette.grey['200']};
  border-radius: ${rem(999)};
  flex: 1;
  height: ${rem(5)};
  min-width: 0;
  overflow: hidden;
`;

const BarFill = styled.div<{ $percentage: number }>`
  background: ${sdsPrimitiveColor.pink['600']};
  border-radius: ${rem(999)};
  height: 100%;
  width: ${({ $percentage }) => `${$percentage}%`};
`;

const Values = styled.div`
  align-items: baseline;
  display: flex;
  flex-shrink: 0;
  gap: ${rem(8)};
`;

const Percentage = styled.span`
  color: ${({ theme }) => theme.palette.common.black};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${rem(10)};
  line-height: ${rem(14)};
`;

const Index = styled.span`
  color: ${({ theme }) => theme.palette.common.black};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${rem(10)};
  line-height: ${rem(14)};
`;

export default {
  Root,
  Title,
  Rows,
  Row,
  Label,
  BarRow,
  BarTrack,
  BarFill,
  Values,
  Percentage,
  Index
};
